/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/fighter_4v4': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<circle pid="0" cx="30" cy="30" r="2"/><circle pid="1" cx="2" cy="30" r="2"/><circle pid="2" cx="30" cy="2" r="2"/><circle pid="3" cx="2" cy="2" r="2"/><g><path pid="4" d="M15.5 21h1v3h-1zM18 15v-2h-4v2l-3 4h4v1h2v-1h4zM14.5 12h3a.5.5 0 000-1h-1V8h-1v3h-1a.5.5 0 000 1z"/></g><g><path pid="5" d="M3 12.254H2v-4.29l3.72-2.136.498.867L3 8.543zM19.221 2.926L16 1.077l-3.22 1.849-.498-.867L16-.077l3.718 2.136zM30 12.254h-1V8.543l-3.218-1.848.497-.867L30 7.964zM26.279 26.173l-.497-.866L29 23.458v-3.71h1v4.29zM16 32.077l-3.718-2.136.498-.866L16 30.923l3.221-1.848.497.866zM5.72 26.173L2 24.038v-4.29h1v3.71l3.218 1.849z"/></g>'
  }
})
